import React from "react";
import { NavLink } from "react-router-dom";
import { useRootAppStore } from "@hooks";

type AccountLockItem = {
	path: string;
	translation: string;
	secondaryTranslation: string;
};

export default function AccountLockItem(props: AccountLockItem) {
	const { path, translation, secondaryTranslation } = props;
	const rootStore = useRootAppStore();

	const IsOasisLockEnabled = rootStore.userAuthStore.user?.isOasisEnabled;

	return (
		<li className="nav--tertiary__item">
			<NavLink
				to={path}
				className="nav--tertiary__link"
				activeClassName="is-active"
				isActive={(_, location) => location.pathname.includes(path)}
			>
				<span className="nav--tertiary__title">
					{IsOasisLockEnabled ? translation : secondaryTranslation}
				</span>
			</NavLink>
		</li>
	);
}
